import { motion, useAnimation } from "framer-motion";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { useEffect } from "react";
import { twMerge } from "tailwind-merge";

function SideModalClose({ onClick, className = "", closeStroke = "#000" }) {
  const controls = useAnimation();
  const handleClose = () => {
    controls.start({
      opacity: 1,
      transition: { duration: 0.1 },
    });
    onClick();
  };
  useEffect(() => {
    controls.start({
      opacity: 1,
      transition: { duration: 0.5 },
    });
  }, [controls]);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClick();
      }
    };
    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [onClick]);

  return (
    <motion.button
      className={twMerge(
        `z-[1] absolute right-5 top-6 bg-white w-11 h-11 flex justify-center items-center rounded-full hover:bg-white/80 transition-all hover:scale-[1.025] mobile:h-8 mobile:w-8 mobile:right-3 mobile:top-1`,
        className
      )}
      onClick={handleClose}
      animate={controls}
    >
      <CloseIcon className="mobile:w-4" stroke={closeStroke} />
    </motion.button>
  );
}

export default SideModalClose;
